import { firstValueFrom, Observable } from 'rxjs';

export async function gqlToPromise<T>(fn: () => Observable<GraphqlResponse<T>>) {
  const resp = await firstValueFrom(fn());

  if (!resp.success) {
    throw new Error('Failed to fetch data', { cause: resp.errors });
  }

  return resp.data;
}
